<div
  class="formula-editor-wrapper"
  [class.formula-editor-interaction-locked]="editorInteractionBlocked"
>
  <!-- Botón/Input que abre el editor -->
  <div class="formula-input-container">
    <input
      type="text"
      pInputText
      [value]="displayValue"
      (click)="openEditor()"
      (focus)="openEditor()"
      readonly
      [tabindex]="editorInteractionBlocked ? -1 : 0"
      [placeholder]="'WXRL.FORMULA.EDIT_PLACEHOLDER' | translate"
      class="w-full"
      [class.p-invalid]="!isValid && validationError"
    />
    <p-button
      icon="pi pi-pencil"
      [text]="true"
      [rounded]="true"
      (click)="openEditor()"
      [disabled]="editorInteractionBlocked"
      [pTooltip]="'WXRL.FORMULA.EDIT_TOOLTIP' | translate"
      tooltipPosition="top"
    ></p-button>
  </div>
  <small class="p-error" *ngIf="!isValid && validationError">
    {{ validationError }}
  </small>
</div>

<!-- Diálogo del editor de fórmulas -->
<p-dialog
  #formulaDialog
  [(visible)]="dialogVisible"
  [modal]="true"
  [style]="{ width: '800px' }"
  [header]="'WXRL.FORMULA.EDITOR_TITLE' | translate"
  [draggable]="false"
  [resizable]="false"
  (onHide)="closeEditor()"
>
  <div class="formula-editor-content formula-form-grid">
    <label for="formula-textarea" class="formula-label">{{ "WXRL.FORMULA.FORMULA_LABEL" | translate }}</label>
    <div class="formula-field">
    <!-- Barra de herramientas -->
    <div class="formula-toolbar">
      <!-- Operadores lógicos -->
      <div class="toolbar-group">
        <button
          type="button"
          class="toolbar-button"
            [title]="'WXRL.FORMULA.OPERATOR_AND' | translate"
          (click)="insertOperator('AND')"
        >
            {{ "WXRL.FORMULA.OPERATOR_AND" | translate }}
        </button>
        <button
          type="button"
          class="toolbar-button"
            [title]="'WXRL.FORMULA.OPERATOR_OR' | translate"
          (click)="insertOperator('OR')"
        >
            {{ "WXRL.FORMULA.OPERATOR_OR" | translate }}
        </button>
        <button
          type="button"
          class="toolbar-button"
            [title]="'WXRL.FORMULA.OPERATOR_OPEN_PAREN' | translate"
          (click)="insertOperator('(')"
        >
          (
        </button>
        <button
          type="button"
          class="toolbar-button"
            [title]="'WXRL.FORMULA.OPERATOR_CLOSE_PAREN' | translate"
          (click)="insertOperator(')')"
        >
          )
        </button>
      </div>

      <!-- Condiciones -->
      <div
        class="toolbar-group condition-group"
        *ngIf="conditionOptions && conditionOptions.length > 0"
      >
        <button
          *ngFor="let condition of conditionOptions; trackBy: trackByCondition"
          type="button"
          class="toolbar-button"
          [title]="condition.label"
          (click)="insertCondition(condition.value, $event)"
        >
          {{ condition.value }}
        </button>
      </div>
    </div>
    <!-- Campo Fórmula -->
      <textarea
        id="formula-textarea"
        pInputTextarea
        [formControl]="formulaControl"
        rows="3"
        class="w-full"
        [maxlength]="255"
        [class.p-invalid]="!isValid && validationError"
        [placeholder]="'WXRL.FORMULA.EXAMPLE_PLACEHOLDER' | translate"
        style="border-radius: 0px 0px 4px 4px;"
      ></textarea>
      <small class="p-text-secondary">
        {{ formulaText.length }} / 255 {{ "WXRL.FORMULA.CHARACTERS" | translate }}
      </small>
      <small class="p-error" *ngIf="!isValid && validationError">
        {{ validationError }}
      </small>
      <small
        class="p-error"
        *ngIf="formulaControl.hasError('required') && formulaControl.touched"
      >
        {{ "WXRL.FORMULA.REQUIRED_ERROR" | translate }}
      </small>
      <small
        class="p-error"
        *ngIf="formulaControl.hasError('maxlength') && formulaControl.touched"
      >
        {{ "WXRL.FORMULA.MAXLENGTH_ERROR" | translate }}
      </small>
    </div>

    <!-- Resumen de condiciones -->
    <label for="conditions-summary" class="formula-label">{{ "WXRL.FORMULA.CONDITIONS_SUMMARY" | translate }}</label>
      <textarea
      id="conditions-summary"
        pInputTextarea
        [value]="getConditionsSummary()"
        rows="8"
      class="w-full formula-input"
        readonly
        style="background-color: #f8f9fa"
      ></textarea>
  </div>

  <ng-template pTemplate="footer">
    <div class="dialog-footer">
      <p-button
        [label]="'WXRL.FORMULA.CANCEL' | translate"
        icon="pi pi-times"
        (click)="closeEditor()"
        severity="secondary"
        [text]="true"
      ></p-button>
      <p-button
        [label]="'WXRL.FORMULA.SAVE' | translate"
        icon="pi pi-check"
        (click)="saveFormula()"
        [disabled]="!formulaControl.valid || !isValid"
      ></p-button>
    </div>
  </ng-template>
</p-dialog>
